'use client'
import { SectionContent } from "@/types/sections.model";
import { Box, Container } from "@mui/material";
import FadeIn from "@/components/ui/FadeIn";
import VideoPlayer from "@/components/ui/VideoPlayer";
import { convertToNoCookieUrl } from '@/lib/videoUtils';

const Video: React.FC<{ section: SectionContent<'video'> }> = ({ section }) => {

  const { id, media } = section;

  return (
    <Box id={id} pt={{ xs: 0, lg: 24 }}>
      <Container>
        <FadeIn>
          <VideoPlayer
            src={convertToNoCookieUrl(media.source)}
            poster={media.poster || null}
            autoplay={media.autoplay || false}
            muted={media.muted || false}
            loop={media.loop || false}
            controls={media.controls || false}
            aspectRatio={media.aspectRatio || '16/9'}
          />
        </FadeIn>
      </Container>
    </Box>
  )
}

export default Video;